var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirmation-sms',{attrs:{"ciemException":_vm.ciemException,"loading":_vm.loading,"tel":_vm.$auth.tel()},on:{"cancelAuth":_vm.cancelAuth,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }